import React, { useEffect, useCallback, useState} from 'react';
import Colors from 'components/Colors.js';
import {connect} from 'react-redux';
import {useSlotDrop} from './useSlotDrop.js';
import {
    setArrangementBottomMode,
    setSelectedZObject,
    setShowPianoRoll,
    setContextualHelp,
    setParameterSliderDown,
    setSampleTagDragging,
    setTrackDragging,
    setSampleDragging
} from 'actions/index.js';

const colors = new Colors();

const EmptySlot = ({
    sampleDragging,
    slotNumber,
    pad,
    sampleTagDragging,
    setSampleDragging,
    setSampleTagDragging,
    slot,
    trackDragging,
    setTrackDragging,
    setParameterSliderDown,
    setArrangementBottomMode,
    setShowPianoRoll,
    size,
    setContextualHelp,
    setSelectedZObject,
    scale,
    attributes
}) => { 
    const {onDrop} = useSlotDrop({
        sampleDragging,
        slotNumber,
        pad,
        sampleTagDragging,
        setSampleDragging,
        setSampleTagDragging,
        slot,
        trackDragging,
        setTrackDragging
    });
    
    return (
        <div
          style={{
              backgroundColor: attributes ? attributes["slot-color"] &&
                  colors.transparent(
                      colors.saturate(attributes["slot-color"], 1),
                      attributes["slot-opacity"] || 1) : undefined,
              width: size,
              height: size,
              margin: 3*scale + 'px'
          }}
          onClick={(e) => {
              e.stopPropagation();
              setSelectedZObject(undefined);
          }}
          onDrop={onDrop} className="empty pad-slot"></div>
    );
}

const mapStateToProps = (state, props) => {
    return {
        sampleDragging: state.selector.sampleDragging,
        sampleTagDragging: state.selector.sampleTagDragging,
        trackDragging: state.tracks.trackDragging,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setSampleDragging : (sample) => dispatch(setSampleDragging(sample)),
      setTrackDragging : (track) => dispatch(setTrackDragging(track)),
      setSampleTagDragging : (sample) => dispatch(setSampleTagDragging(sample)),
      setParameterSliderDown: parameter => dispatch(setParameterSliderDown(parameter)),
      setArrangementBottomMode: x => dispatch(setArrangementBottomMode(x)),
      setShowPianoRoll: x => dispatch(setShowPianoRoll(x)),
      setContextualHelp: x => dispatch(setContextualHelp(x)),
      setSelectedZObject: x => dispatch(setSelectedZObject(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EmptySlot);
